// extracted by mini-css-extract-plugin
module.exports = {"spinner":"PageLoadingSpinner_spinner__1qg8G"};